import {load} from '@shopify/theme-sections';

import '../sections/tagalys-recommendations';

import renderProductCard from '../components/product-card-template';

const template = '404';

export default (function () {
  if (document.body.dataset.template !== template) {
    return;
  }
  load('*');
})();

window.addEventListener("DOMContentLoaded", function () {
  const tagalysContainer = document.querySelector('[data-widget-id]');
  if (!tagalysContainer) {
    return;
  }

  const blockId = tagalysContainer.getAttribute('data-block-id') ?? '';
  const widgetId = tagalysContainer.getAttribute('data-widget-id') ?? '';

  Tagalys.UIWidgets.SmartWidget.init(
    `[data-block-id='${blockId}']`,
    {
      widgetId: widgetId,
      templates: {
        widget: {
          options: {
            limit: 8,
            displayFormat: 'carousel',
            includeTagalysCSS: false,
            carouselOptions: {
              perPage: {
                300: 2,
                768: 3,
                1280: 4,
              },
            },
          },

          render: function (html, args) {
            const {props} = args;
            const {helpers} = props;
            const products = helpers.getProducts();

            if (props.loading === false) {
              if (products.length === 0) {
                return null;
              }
              return html`
                <div class="container product-recommendations">
                  <${args.templates.header} />
                  <${args.templates.productList} />
                </div>
              `;
            }
          },
        },
        header: {
          render: function (html, args) {
            return html`<h2 class="product-recommendations__heading">Recommended for You</h2>`;
          },
        },
        products: {
          render: function (html, args) {
            const {props} = args;
            const products = props.helpers.getProducts();

            return html`
              <div class="products products-carousel">
                ${products.map((product, index) => {
                  return html` <${args.templates.product} key=${index} product=${product} /> `;
                })}
              </div>
            `;
          },
          callbacks: {
            afterEveryRender: function () {
              document.dispatchEvent(new CustomEvent('results-grid:loaded'));
            },
          },
        },
        product: {
          render: function (html, args) {
            const {props} = args;
            const {product, helpers} = props;

            return html`<div dangerouslySetInnerHTML=${{__html: renderProductCard(product, helpers)}} />`;
          },
        },
        carouselActions: {
          render: function (html, args) {
            const {props} = args;

            return html`
              <button
                class="products-carousel__btn products-carousel__prev"
                disabled=${props.helpers.carousel.isFirstSlide()}
                onClick=${props.helpers.carousel.goLeft}
              >
                <svg
                  aria-label="Chevron left icon"
                  class="icon icon-chevron-left"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m14 18-6-6 6-6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>

              <button
                class="products-carousel__btn products-carousel__next"
                disabled=${props.helpers.carousel.isLastSlide()}
                onClick=${props.helpers.carousel.goRight}
              >
                <svg
                  aria-label="Chevron right icon"
                  class="icon icon-chevron-right"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m10 18 6-6-6-6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>
            `;
          },
        },
      }
    }
  );
});